export function formatTicketStatus(status) {
  switch (status) {
    case 'open':
      return 'Open';
    case 'in_progress':
      return 'In progress';
    case 'resolved':
      return 'Resolved';
    case 'closed':
      return 'Closed';
    default:
      return 'Unknown';
  }
}

export function formatTicketPriority(priority) {
  switch (priority) {
    case 'low':
      return 'Low';
    case 'normal':
      return 'Normal';
    case 'high':
      return 'High';
    case 'urgent':
      return 'Urgent';
    default:
      return 'Normal';
  }
}

export function toJsDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value?.toDate === 'function') return value.toDate();
  // Firestore Timestamp (common shapes)
  if (typeof value?.seconds === 'number') return new Date(value.seconds * 1000);
  // Serialized Timestamp from some transports (e.g., callable functions) often uses _seconds/_nanoseconds
  if (typeof value?._seconds === 'number') {
    const ms = value._seconds * 1000 + Math.floor((value._nanoseconds || 0) / 1e6);
    return new Date(ms);
  }
  // Sometimes timestamps are stored as ISO strings
  if (typeof value === 'string') {
    const d2 = new Date(value);
    return Number.isNaN(d2.getTime()) ? null : d2;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

